(() => {
    const initializeWishlist = (container) => {
      container.querySelectorAll('.be-wishlist').forEach((element) => {
        if (element.querySelector('button')) return;
        document.dispatchEvent(new CustomEvent('wishlist-hero-add-to-custom-element', { detail: element }));
      });
    };

    const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;',
    })[character]);
    const money = (cents) => new Intl.NumberFormat('ja-JP', {
      style: 'currency', currency: 'JPY', maximumFractionDigits: 0,
    }).formatToParts(Number(cents || 0) / 100).map(({ type, value }) =>
      type === 'currency' ? '<span class="be-recent-yen">¥</span>' : escapeHtml(value)
    ).join('');
    const getProductImages = (product) => {
      const images = product.media?.length
        ? product.media.map((media) => media.preview_image?.src || '')
        : product.images || [];
      const primary = images[0] || '';
      const hover = images[1] || primary;
      return { primary, hover };
    };
    const createRecentCard = (product, productGroup = 'staff_recent', hideRating = false) => {
      const { primary, hover } = getProductImages(product);
      const compareAt = Number(product.compare_at_price || 0);
      const price = Number(product.price || 0);
      const variant = product.variants?.find((item) => item.available) || product.variants?.[0];
      const isSale = compareAt > price;
      const offRate = isSale ? Math.floor(((compareAt - price) * 100) / compareAt) : 0;
      const card = document.createElement('article');
      card.className = `product-card be-product-card${isSale ? ' product-card--sale' : ''}`;
      card.dataset.productGroup = productGroup;
      card.dataset.productHandle = product.handle || '';
      card.dataset.productAvailable = String(product.available !== false);
      card.innerHTML = `
        <a class="product-card__link-overlay" href="${escapeHtml(product.url || `/products/${product.handle}`)}" aria-label="${escapeHtml(product.title)}"></a>
        <div class="product-card-visual"><div class="product-image">
          <img class="product-image-primary" src="${escapeHtml(primary)}" loading="lazy" alt="${escapeHtml(product.title)}">
          <img class="product-image-hover" src="${escapeHtml(hover)}" loading="lazy" alt="" aria-hidden="true">
          ${isSale ? `<span class="product-card__sale-badge">${offRate}%OFF</span>` : ''}
          <div class="wishlist-hero-custom-button be-wishlist" data-wlh-id="${escapeHtml(product.id)}"
            data-wlh-link="${escapeHtml(new URL(product.url || `/products/${product.handle}`, window.location.origin).href)}"
            data-wlh-variantid="${escapeHtml(variant?.id || '')}" data-wlh-price="${Number(variant?.price || price) / 100}"
            data-wlh-name="${escapeHtml(product.title)}" data-wlh-image="${escapeHtml(primary)}"
            data-wlh-mode="icon_only" data-wlh-view="Collection" data-wlh-classes="be-favorite"></div>
        </div><p class="category-label">${escapeHtml(product.type || '')}</p></div>
        <div class="product-card-info"><h3>${escapeHtml(product.title)}</h3>
          ${hideRating ? '' : '<div class="rating rating--empty" aria-hidden="true"></div>'}
          <p class="price product-card__price${isSale ? ' product-card__price--sale' : ''}">
            ${isSale && productGroup !== 'recent' ? `<del class="product-card__price--compare">${money(compareAt)}</del><span class="product-card__sale-arrow" aria-hidden="true">→</span>` : ''}
            <span${isSale ? ' class="product-card__sale-price"' : ''}>${money(price)}</span>
          </p>
        </div>`;
      return card;
    };
    const loadRecentSection = async (section) => {
      const slider = section.querySelector('[data-recent-slider]');
      if (!slider) return;
      let history = [];
      try { history = JSON.parse(localStorage.getItem(section.dataset.recentSource) || '[]'); } catch (error) { history = []; }
      if (!Array.isArray(history)) history = [];
      const handles = [...new Set(history.slice().reverse().map((item) => {
        const match = String(item?.productUrl || '').match(/\/products\/([^?#/]+)/);
        return match?.[1];
      }).filter(Boolean))].slice(0, 10);
      if (!handles.length) return;
      const products = (await Promise.all(handles.map(async (handle) => {
        try {
          const response = await fetch(`/products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' });
          if (!response.ok) return null;
          const product = await response.json();
          return product.available === false ? null : product;
        } catch (error) { return null; }
      }))).filter(Boolean);
      if (!products.length) return;
      const cards = await Promise.all(products.map(async (product) => {
        const card = createRecentCard(product, 'recent', true);
        try {
          const response = await fetch(`/products/${encodeURIComponent(product.handle)}?view=be-card`, { credentials: 'same-origin' });
          if (!response.ok) return card;
          const document = new DOMParser().parseFromString(await response.text(), 'text/html');
          const info = document.querySelector('.be-product-card .product-card-info');
          if (info) {
            info.querySelectorAll('.product-card__points').forEach((points) => points.remove());
            info.querySelectorAll('.product-card__price-row--with-points').forEach((row) => row.classList.remove('product-card__price-row--with-points'));
            card.querySelector('.product-card-info').classList.add('product-card-info--desktop');
            info.classList.add('product-card-info--mobile');
            card.append(info);
          }
        } catch (error) { /* Retain the existing card when the HTML view is unavailable. */ }
        return card;
      }));
      slider.replaceChildren(...cards);
      section.hidden = false;
      initializeWishlist(slider);
    };


  const initialized = new WeakSet();
  const initAll = () => document.querySelectorAll('[data-recent-products]').forEach(section => {
    if (initialized.has(section)) return;
    initialized.add(section);
    loadRecentSection(section).then(() => {
      const title = section.querySelector('h2');
      if (section.hidden || !title || section.closest('[data-be-search-top]')) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      title.classList.add('be-recent-reveal');
      const observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        title.classList.add('is-visible');
        observer.disconnect();
      }, { threshold: .12, rootMargin: '0px 0px -5% 0px' });
      observer.observe(title);
    });
  });
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initAll) : initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
